export enum WithdrawalMethods {
  VODAFONE_CASH_METHOD = 'vodafone_cash',
  ORANGE_CASH_METHOD = 'orange_cash',
  ETISALAT_CASH_METHOD = 'etisalat_cash',
  WE_PAY_METHOD = 'we_pay',
  EGP_BANK_TRANSFER_METHOD = 'bank_transfer',
  INTL_BANK_TRANSFER_METHOD = 'international_bank_transfer',
  PAYONEER_TRANSFER_METHOD = 'payoneer',
}
